const VALID_URL_REGEX = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;

export const isValidURI = (url?: string): boolean => {
    if (!url || url.length < 0) {
        return false;
    }

    return VALID_URL_REGEX.test(url);
};

export const serializeParams = <T extends object>(data: T): string => {
    return Object.keys(data)
        .map(key => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
        })
        .join("&");
};
